import request from '@/utils/request'

export function getCustomerServiceList(data) {
  return request({
    url: '/app/customerService/list',
    method: 'get',
    params: data
  })
}
